<template>
  <div class="welcome">
    <h1>欢迎来到纽尔蓝牙灯管理系统</h1>
  </div>
</template>
<script>
export default {
  name: "welcome",
};
</script>
<style lang="less" scoped>
.welcome {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
